import React from 'react'
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ChangeOrder from '../AddContract/change-order';

interface changeOrderInterface {
    modal_change_order:any,
    tog_change_order:any
  }
const CreateChangeOrderModal:React.FC<changeOrderInterface>  = ({modal_change_order,tog_change_order}) => {
    const { t } = useTranslation(); 
    return (
    <Modal
    size="xl"
    show={modal_change_order}
    onHide={() => {
      tog_change_order();
    }}
    backdrop={"static"}
    enforceFocus={false}
    id="staticBackdrop"
    centered
    data-bs-focus="false"
  >
    <Modal.Header
      className="modal-title fw-bold tailwind-prefix"
      id="staticBackdropLabel"
      style={{ background: "rgb(249, 250, 251)" ,
    display:'flex',
    justifyContent:'space-between'
    }}
    >
      {t("Change Order Contract")}
      <button onClick={tog_change_order} >
        <i className='bi bi-x-lg '/>
      </button>
    </Modal.Header>
    <Modal.Body
      className="p-5"
      style={{ background: "rgb(249, 250, 251)" }}
    >
      <ChangeOrder tog_change_order={tog_change_order} />
    </Modal.Body>
  </Modal>
  )
}

export default CreateChangeOrderModal
